// A6.20 — Ommaviy qaror adapter. Module-local. MENING backend endpointlarim
// (/admin/moderation/report-groups + /admin/moderation/bulk-resolve) — A7.03
// ReportGroups (client-aggregate, read-only) dan ALOHIDA: bu ACT qatlami.
import { api } from '@/lib/api'

export interface ModerationGroup {
  target_type: string
  target_id: number
  report_count: number
  reporter_count: number
  categories: string[] | null
  latest_at: number
  latest_reason: string | null
}

export async function fetchModerationGroups(category?: string, limit = 50): Promise<ModerationGroup[]> {
  const r = await api.get<{ items?: ModerationGroup[] }>('/admin/moderation/report-groups', {
    query: { category: category || undefined, limit },
  })
  return r.items ?? []
}

export interface BulkResolveResult {
  resolved: number
  status: string
}

// Bitta obyektga tegishli BARCHA pending shikoyatni bir marta hal qiladi
// (backend status-guarded atomik). dismiss=true → rad etish.
export async function bulkResolveReports(
  targetType: string,
  targetId: number,
  resolution: string,
  dismiss: boolean,
): Promise<BulkResolveResult> {
  return api.post<BulkResolveResult>('/admin/moderation/bulk-resolve', {
    target_type: targetType,
    target_id: targetId,
    resolution,
    dismiss,
  })
}
